/* ============================================================
   Lab Effects — MOBILE CART
   assets/le-mobile-cart.js

   Quantity steppers, remove, and the order-summary toggle for
   sections/le-mobile-cart.liquid.

   Quantity changes POST to /cart/change.js asking for this section's HTML
   back (Section Rendering API), swap it in, then dispatch `cart:update`
   carrying the cart so the tab-bar badge and every other cart listener
   refresh exactly like a native change. Nothing here re-implements pricing:
   the re-rendered Liquid is the source of truth for every number on screen,
   including the free-shipping bar.

   Listeners are delegated off document, so they keep working after the
   section is replaced.
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'le-mobile-cart';
  var busy = false;

  function root() { return document.querySelector('[data-mcart]'); }

  /* The summary footer is fixed, so the item list needs bottom padding equal to
     its height or the last line hides behind it. The footer grows when the
     summary expands, hence measuring rather than hardcoding. */
  function fitFoot() {
    var foot = document.querySelector('[data-mcart-foot]');
    if (!foot) {
      document.documentElement.style.removeProperty('--le-mcart-foot-h');
      return;
    }
    document.documentElement.style.setProperty('--le-mcart-foot-h', foot.offsetHeight + 'px');
  }

  function swap(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // The Section Rendering API returns the section wrapper; take its inner
    // markup so we replace content without nesting wrappers on every change.
    // Swap ONLY [data-mcart-swap]. The section's <link>/<script> tags sit
    // outside that wrapper, so they survive the replace — with them inside,
    // the first stepper tap deleted the cart's own stylesheet and the page
    // rendered unstyled from then on.
    var fresh = doc.querySelector('[data-mcart-swap]');
    var live = document.querySelector('[data-mcart-swap]');
    if (!live || !fresh) return;
    // Keep the live Shiptection block (snippets/le-shiptection.liquid): its
    // widget is a mounted React root, and a fresh copy would sit empty for
    // seconds while Shiptection re-mounts it. le-shiptection.js repaints it.
    var keep = live.querySelector('[data-le-shipt]');
    live.innerHTML = fresh.innerHTML;
    var slot = keep && live.querySelector('[data-le-shipt]');
    if (slot) slot.replaceWith(keep);
    fitFoot();
  }

  // Used by le-shiptection.js to repaint after it removes the protection line.
  window.LEMobileCart = { swap: swap, fitFoot: fitFoot };

  function change(line, quantity) {
    if (busy) return;
    busy = true;

    var item = document.querySelector('.le-mcitem[data-line="' + line + '"]');
    if (item) item.classList.add('is-busy');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/change.js'
      : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: SECTION_ID,
        sections_url: '/cart'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.sections) swap(cart.sections[SECTION_ID]);
        // Same event le-cart-add.js fires, so the badge and drawer stay in sync.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: SECTION_ID }
        }));
      })
      .catch(function () {
        // A failed change must not leave a permanently greyed row.
        if (item) item.classList.remove('is-busy');
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sum-toggle]');
    if (toggle) {
      var lines = document.querySelector('[data-sum-lines]');
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (lines) lines.hidden = open;
      fitFoot();
      return;
    }

    var btn = e.target.closest('[data-qty-up],[data-qty-down],[data-qty-remove]');
    if (!btn || !root()) return;

    var row = btn.closest('.le-mcitem');
    if (!row) return;

    var line = parseInt(row.getAttribute('data-line'), 10);
    if (!line) return;

    var qtyEl = row.querySelector('[data-qty]');
    var qty = qtyEl ? parseInt(qtyEl.textContent.trim(), 10) || 1 : 1;

    if (btn.hasAttribute('data-qty-remove')) change(line, 0);
    else if (btn.hasAttribute('data-qty-up')) change(line, qty + 1);
    else if (qty <= 1) change(line, 0);
    else change(line, qty - 1);
  });

  if (document.readyState !== 'loading') fitFoot();
  else document.addEventListener('DOMContentLoaded', fitFoot);
  window.addEventListener('resize', fitFoot);
})();
